import { render } from "./LoggedUser.vue?vue&type=template&id=23d41d23"
import script from "./LoggedUser.vue?vue&type=script&lang=js"
export * from "./LoggedUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__